<template>
    <div class="modal-container">
        <div class="modal-header">
            <h4 class="modal-title">Change Date</h4>
            <md-button class="md-simple md-just-icon md-round modal-default-button" @click.stop="$modal.hide">
                <md-icon>clear</md-icon>
            </md-button>
        </div>
        <div class="modal-body">
            <p class="sub-header">Select a new date or leave the date blank to assign no date</p>
            <form-wrapper :validator="$v" class="form-wrapper">
                <div class="md-layout">
                    <md-datepicker
                        v-model="form.date"
                        md-immediately
                        :md-debounce="10"
                        :md-disabled-dates="disabledDates"
                    >
                        <label>Date</label>
                    </md-datepicker>
                </div>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <md-button class="md-primary dialog-button" @click="submit">Confirm</md-button>
            <md-button class="md-default dialog-button" @click.stop="$modal.hide">Cancel</md-button>
        </div>
    </div>
</template>

<script>
import { handleRequests } from '@/helpers';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { DATE_TYPES } from '@/utils/constants';

export default {
    name: 'ChangeStopDateModal',
    mixins: [GeneralMixin],
    props: {
        stopIds: {
            type: Array,
            default: () => []
        },
        resolve: {
            type: Function,
            default: () => {}
        }
    },
    validations: {
        date: {
            required
        }
    },
    data() {
        return {
            form: {
                date: null
            },
            disabledDates: (date) => {
                const x = moment(date).format(DATE_TYPES.internationalDate);
                const now = moment().format(DATE_TYPES.internationalDate);
                return !moment(x).isSameOrAfter(now, 'day');
            }
        };
    },
    methods: {
        async submit() {
            this.$_handleLoaderState(true, 'UPDATING...');

            const endpoint = `/api/stops/bulk/change-date`;
            const data = {
                stopIds: this.stopIds,
                date: this.form.date ? moment(this.form.date).format(DATE_TYPES.internationalDate) : null
            };

            const payload = {
                method: 'post',
                data
            };

            try {
                const response = await handleRequests(endpoint, payload);
                this.$v.$reset();
                this.resolve({ errors: response.data });
            } catch (e) {
                if (e.status === 400 && e.data?.length > 0) {
                    let messageObj = {
                        type: 'danger',
                        message: e.data[0]
                    };

                    if (e.data?.length > 1) {
                        const message = e.data.map((error) => `• ${error}`).join('\n');
                        messageObj = {
                            ...messageObj,
                            dangerouslyUseHTMLString: true,
                            message: `<div style="white-space: pre-line">${message}</div>`
                        };
                    }

                    this.$notify(messageObj);
                } else {
                    this.$notify({
                        type: 'danger',
                        message: 'Unable to update stop dates in bulk.'
                    });
                }

                this.resolve(null);
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-container {
    max-width: 500px;
}

.sub-header {
    font-size: 0.8em;
    margin-bottom: 10px;
}

.modal-body {
    padding: 16px 24px;
}
</style>
